const Wedding_Bless = [
  { name: "他是词，你是谱，你俩就是一首和谐的歌。" },
  { name: "天作之合，鸾凤和鸣。千禧年结千年缘，百年身伴百年眠。" },
  { name: "天生才子佳人配，只羡鸳鸯不羡仙。" },
  { name: "各交出一只翅膀，天使新燕，以后共同飞翔在蓝天。" },
  { name: "各交出一份真情，神仙伴侣，以后共同恩爱在人间。" },
  { name: "我交出一毛钱，祝福你们新婚快乐、百年好合！" },
  { name: "珠联壁合洞房春暖，花好月圆鱼水情深。" },
  {
    name: "今天是你们喜结良缘的日子，我代表我家人祝贺你们，祝你俩幸福美满，永寿偕老！",
  },
  {
    name: "花好月圆喜气生，莺歌燕舞传美名，百年佳偶颂同心，喜结连理鸾凤鸣，勤俭持家五世昌，心心相印不了情。祝永结同心！",
  },
];

const companyMeeting = [
  { name: '🎊 今年KPI超额完成！明年加薪必须安排！' },
  { name: '🎁 年会大奖抽我抽我！锦鲤本鲤在此！' },
  { name: '🍻 辛苦一年了！今晚不醉不归！' },
  { name: '💃 终于等到放飞自我的时刻！嗨起来！' },
  { name: '🏆 愿我们团队明年继续横扫市场！' },
  { name: '💰 年终奖厚一点！老板帅一点！' },
  { name: '✨ 去年表现不错！明年我要当销冠！' },
  { name: '🤩 求年会抽中带薪休假！拜托拜托~' },
  { name: '🎯 新年目标：钱多事少离家近！' },
  { name: '💪 今年搬砖辛苦了！明年继续努力！' }
];

// ==========新增祝福语开始==========
const communityActivity = [
  { name: "🏘️ 邻里相聚，和睦相伴，祝社区活动圆满顺利！" },
  { name: "🤝 邻里同心，守望相助，愿大家度过愉快时光！" },
  { name: "🌷 欢聚一堂，共享美好社区生活！" },
  { name: "🎉 睦邻友好，喜乐相伴，祝各位街坊万事顺心！" },
  { name: "☀️ 相聚即是缘分，愿社区越来越温暖！" },
  { name: "🎈 邻里同乐，平安喜乐，日子红红火火！" },
  { name: "🍵 以活动为纽带，拉近你我邻里情谊！" },
  { name: "✨ 愿邻里和睦，岁岁安康，事事如意！" },
  { name: "🎐 欢聚此刻，共筑美好社区！" },
  { name: "💐 祝本次社区活动圆满成功！" }
];

const birthdayBless = [
  { name: "🎂 生日快乐！岁岁常欢愉，年年皆胜意！" },
  { name: "🎈 愿平安喜乐围绕，所求皆如愿！" },
  { name: "🎁 生辰吉乐，福寿安康，万事顺意！" },
  { name: "🥳 新岁新光景，日子闪闪发光！" },
  { name: "✨ 愿岁月温柔以待，好运常伴左右！" },
  { name: "🍰 生日快乐，阖家幸福，笑口常开！" },
  { name: "🎊 岁岁无忧，自在欢喜，前程坦荡！" },
  { name: "💐 祝生辰快乐，多喜乐，长安宁！" },
  { name: "🌟 愿所有美好与幸运如约而至！" },
  { name: "🥂 不负时光，不负自己，生日快乐！" }
];

const lotteryBless = [
  { name: "🎲 好运降临！祝大家手气爆棚！" },
  { name: "🍀 锦鲤附体，大奖花落谁家！" },
  { name: "🎁 福气满满，希望好运砸中自己！" },
  { name: "🎉 碰碰手气，期待惊喜降临！" },
  { name: "💰 愿好运加持，喜得心仪奖品！" },
  { name: "✨ 福气已就位，坐等开奖！" },
  { name: "🎊 人人有好运，惊喜不停歇！" },
  { name: "🍻 祝各位好运连连，心想事成！" },
  { name: "🌟 希望幸运眷顾，收获满满！" },
  { name: "🎯 好运开跑，期待属于自己的惊喜！" }
];

const businessActivityBless = [
  { name: "🛍️ 商场活动热闹开启，祝大家逛得开心！" },
  { name: "🎊 人气爆棚，生意兴隆，活动大卖！" },
  { name: "🎁 好物多多，福利满满，尽兴选购！" },
  { name: "✨ 祝商场活动红红火火，客似云来！" },
  { name: "🛒 欢乐购物，收获实惠与快乐！" },
  { name: "🏮 热闹相聚，祝本次活动圆满成功！" },
  { name: "💫 好物享不停，好运伴随行！" },
  { name: "💰 买卖兴旺，八方来客，财源滚滚！" },
  { name: "🎈 欢聚商场，共享热闹好时光！" },
  { name: "💐 祝活动顺顺利利，皆大欢喜！" }
];

const graduationBanquetBless = [
  { name: "🎓 金榜题名，前程似锦！未来大有可为！" },
  { name: "📚 十年寒窗终有获，宏图大展正当时！" },
  { name: "🎉 恭贺升学，愿鹏程万里，逐梦远航！" },
  { name: "✨ 韶华不负，青云直上，未来闪闪发光！" },
  { name: "🎊 喜登金榜，学业精进，步步登高！" },
  { name: "🌟 今朝折桂，来日乘风破浪！" },
  { name: "🥂 恭贺升学之喜，愿不负韶华，一路繁花！" },
  { name: "💐 学海扬帆，前程浩荡，万事可期！" },
  { name: "🎈 少年有志，未来璀璨，祝学业有成！" },
  { name: "🏆 喜获佳绩，奔赴山海，前程万里！" }
];

const memorialBless = [
  { name: "🕯️ 缅怀逝者，愿逝者安息，生者安康。" },
  { name: "🤍 追思故人，音容犹在，愿天堂没有苦痛。" },
  { name: "🙏 寄哀思于心中，愿故人安好，家人节哀珍重。" },
  { name: "🕊️ 遥寄思念，愿逝者长眠，亲友平安顺遂。" },
  { name: "💔 怀缅往昔，万般思念，望家人保重身体。" },
  { name: "🌫️ 幽幽追思，愿故人安息，岁岁常怀念。" },
  { name: "🙏 心存感念，遥寄哀思，望生者珍重自身。" },
  { name: "🕯️ 追忆往昔点滴，愿逝者归于安宁。" },
  { name: "🤍 山河依旧，思念长存，愿家人平安健康。" },
  { name: "🕊️ 一别永念，愿逝者安息，人间皆安。" }
];
// ==========新增祝福语结束==========

const defaultBless = [
  { name: '🎊 心想事成，万事如意！' },
  { name: '🎉 好运连连，幸福满满！' },
  { name: '🎁 平安喜乐，得偿所愿！' },
  { name: '🎈 前程似锦，未来可期！' },
  { name: '🎀 阖家欢乐，幸福安康！' },
  { name: '🎆 事业顺利，步步高升！' },
  { name: '🎗️ 身体健康，青春永驻！' },
  { name: '🎐 财源广进，富贵吉祥！' },
  { name: '🎑 花好月圆，人长久久！' },
  { name: '🎠 笑口常开，快乐常在！' }
];

const jobHunt = [
  { name: "💼 求职乘风破浪，offer稳稳到手！" },
  { name: "🚀 才华遇伯乐，斩获心仪offer！" },
  { name: "✨ 笔面试皆顺利，前程闪闪发光！" },
  { name: "📄 简历出彩，面试从容，成功上岸！" },
  { name: "🎯 把握机遇，找到理想好工作！" },
  { name: "🌟 以才赴岗，不负努力，未来可期！" },
  { name: "📈 职途坦荡，薪资理想，步步高升！" },
  { name: "💪 自信登场，脱颖而出，成功拿offer！" },
  { name: "🎊 伯乐识良才，求职一路开挂！" },
  { name: "🌱 奔赴新岗位，开启职业新征程！" },
];

const chatGroup = [
  { name: "🌞 早安吉祥！愿群里各位今天事事顺心如意，好运连连！" },
  { name: "🌸 签到打卡！祝福群友们身体健康，工作顺利，笑口常开~" },
  { name: "💝 美好的一天从签到开始，愿群里每位朋友心想事成！" },
  { name: "🍀 签到送福！祝大家事业蒸蒸日上，家庭幸福美满！" },
  { name: "🌈 群友们早上好！愿我们今天的努力都能收获满满！" },
  { name: "🎉 签到报到！祝福群里兄弟姐妹们天天开心，烦恼全消！" },
  { name: "🥰 亲爱的群友们好！愿我们友谊长存，快乐永驻！" },
  { name: "✨ 签到打卡！愿群里每位朋友都能遇见美好的一天！" },
  { name: "💪 群友们加油！新的一天，新的希望，我们一起努力！" },
  { name: "🤗 签到问候！愿群里充满欢声笑语，温暖常在！" }
];

const meetingSales = [
  { name: '💰 祝我手气爆棚，抢到就是赚到！' },
  { name: '🎁 好运加持，今天必薅到大羊毛~' },
  { name: '✨ 愿我选到心仪好物，生活闪闪发光！' },
  { name: '🛒 购物车装满快乐，钱包依然鼓鼓~' },
  { name: '💝 今天买买买，明天夸夸夸！' },
  { name: '🏆 我就是今天的幸运锦鲤本鲤！' },
  { name: '🍀 手速快人一步，好物抢先到手！' },
  { name: '🎯 精准剁手，只买对的！' },
  { name: '🤩 愿我淘到宝藏，开心到跺jiojio~' },
  { name: '💪 买它买它！我值得最好的！' }
];

const uyghur_Wedding = [
  {
    name: "تويۇڭلار مۇبارەك بولسۇن، ئۆمرۈڭلار بىللە ئۆتكۈسۇن، بەخت-سائادىتىڭلار تۈگىمەسۇن!",
    description: "祝你们婚礼幸福，白头偕老，永浴爱河！",
    english: "Congratulations on your wedding, may you live together happily forever, and may your happiness be endless!"
  },
  {
    name: "يېڭى تۇرمۇشىڭلار غۇلمۇ گل بولسۇن، مۇھەببىتىڭلار چېچەك ئېچىۋاتقاندەك گۈللىنىپ گۈل بولسۇن!",
    description: "愿你们的新生活如花绽放，爱情如花朵盛开！",
    english: "May your new life bloom like flowers, and may your love blossom like blooming flowers!"
  },
  {
    name: "ئۆمرۈڭلار بىر ئۆمۈر بولسۇن، بەختىڭلار تېخىمۇ كۆپ بولسۇن، سۆيگۈڭلار مەڭگۈلۈك بولسۇن!",
    description: "愿你们白头偕老，幸福美满，爱情永恒！",
    english: "May you live a long life together, be happier, and may your love be eternal!"
  },
  {
    name: "تويۇڭلارغا چوڭقۇر تەبرىكلەيمەن! مۇھەببەت ۋە ھۆرمەت بىلەن تولغۇن بىر ئۆمر ئارزۇ قىلىمەن!",
    description: "深深祝贺你们的婚礼！祝你们充满爱与尊重的一生！",
    english: "My deepest congratulations on your wedding! Wishing you a lifetime filled with love and respect!"
  },
  {
    name: "يېڭى تۇرمۇشقا قەدەم قويغان يېڭىلارغا مۇبارەك! بەخت-سائادىتىڭلار ھەمىشە ۋەسسىلەپ تۇرسۇن!",
    description: "祝贺新人步入新生活！愿幸福永远伴随着你们！",
    english: "Congratulations to the newlyweds on stepping into a new life! May happiness always accompany you!"
  },
  {
    name: "مۇھەببەت دېرىيىڭلار ھەرگىز قۇرۇمايسۇن، ھۆرمەت تېغىڭلار ھەرگىز تۆۋەنلىمىسۇن!",
    description: "愿你们的爱河永不干涸，尊重的山峰永不降低！",
    english: "May your river of love never run dry, and may your mountain of respect never diminish!"
  },
  {
    name: "تويۇڭلار مۇبارەك، ئائىلەڭلار پەخىر بولسۇن، بالا-چاقىڭلار ساغلام بولسۇن!",
    description: "祝你们婚姻美满，家庭骄傲，孩子健康！",
    english: "Happy wedding, may your family be proud, and may your children be healthy!"
  },
  {
    name: "يېڭى ئائىلەڭلاردا ھەمىشە كۈلۈملىرىڭلار ھۆكۈم سۈرسۇن، كۆڭۈللەرڭلار ھەرگىز ئاجراشمىسۇن!",
    description: "愿你们的家庭永远充满欢笑，心永远不分离！",
    english: "May your new home always be filled with laughter, and may your hearts never be apart!"
  },
  {
    name: "مۇھەببەت يولىدا ھەمىشە بىر-بىرىڭلارنى قوللاشلاڭ، ھەرگىز ئايرىلماڭ!",
    description: "在爱的道路上永远互相支持，永不分离！",
    english: "Always support each other on the path of love, never be apart!"
  },
  {
    name: "تويۇڭلار مۇبارەك بولۇپ، مۇھەببەت چېچەكلىرىڭلار ھەمىشە گۈللىنىپ تۇرسۇن!",
    description: "祝贺你们新婚，愿你们的爱情之花永远盛开！",
    english: "Congratulations on your wedding, may the flowers of your love always bloom!"
  },
  {
    name: "ئاللاھ بەخت-سائادىتىڭلارنى ھەمىشە كۆپەيتىپ، ساغلام-سالمەت، ئۇزۇن ئۆمر بەرسۇن!",
    description: "愿真主使你们的幸福倍增，赐予你们健康长寿！",
    english: "May Allah multiply your happiness and grant you health and long life!"
  },
  {
    name: "يېڭى تۇرمۇشىڭلاردا ھەر كۈنى يېڭى بەختلەر بىلەن تونۇپ، ھەر كۈنى يېڭى سۆيگۈ بىلەن تېرىپ تۇرۇڭ!",
    description: "愿你们的新生活每天都有新的幸福，每天都有新的爱！",
    english: "May your new life be filled with new happiness every day, and new love every day!"
  },
  {
    name: "مۇھەببەت ئوتىڭلار ھەرگىز سۈنمىسۇن، ھۆرمەت ئۆيىڭلار ھەرگىز بوشلانمىسۇن!",
    description: "愿爱的火焰永不熄灭，尊重的房子永不满！",
    english: "May the flame of love never go out, and may the house of respect never be empty!"
  },
  {
    name: "تويۇڭلار مۇبارەك بولۇپ، بىر-بىرىڭلارغا ھەرگىز ۋاپاسىزلىك قىلماڭ!",
    description: "祝你们新婚快乐，永远不要辜负彼此！",
    english: "Congratulations on your wedding, never be unfaithful to each other!"
  },
  {
    name: "يېڭى ئائىلەڭلاردا ھەمىشە ئىناق-ئىتتىپاق، ھەممە ئىشلاردا مۇۋەپپەقىيەت بولسۇن!",
    description: "愿你们的家庭永远和谐，万事成功！",
    english: "May your family always be harmonious and successful in everything!"
  }
];

export const defaultAvatar = require("@/assets/images/logo.png");

export const WS_Status = {
  unconnected: 0,
  connected: 1,
  connect_close: -1,
  connected_err: -2
}

export const _code = {
  HEAT_BEAT: "H0000",  // "心跳报文"
  ACTION_CODE: "A0000", // "遥控器指令"
  SUBSCRIBE_MP: "W0001", //"关注公众号"
  UNFOLLOW_MP: "W0002", // "取消关注公众号"
  JOIN_LIVE: "W0003", // "加入活动"
  RECHARGE_LIVE_SUCCESS: "P0001", //"活动套餐充值成功"
  COIN_REWARD: "P0002", //"奖励金币"
  GEN_QRCODE_SUCCESS: "P0003", // "生成二维码成功"
  RECHARGE_RED_PACKET_SUCCESS: "P0004", // "现金红包充值成功"
  LOTTERY_GIFT_ORDER_SUCCESS: "P0005", // "中奖概率提升"
  RECHARGE_SUCCESS: "P0006", // "充值成功"
  GET_RED_PACKET_SUCCESS: "P0007", //"抽中红包"
  SIGN_REWARD_SUCCESS: "P0008",// "签到奖励红包"
  REFRESH_USER_COIN: "P0009", // "刷新用户金币"
  REFRESH_LIVE_COIN: "P0010", //"刷新活动金币"
  CONN_SUCCESS: "M0001", // "连接成功"
  SEND_GIFT: "M1001", //"发送礼物"
  SEND_MSG: "M1002", //"发送消息"
  SEND_NOTICE: "M1003", //"发送通知"
  SEND_CARD: "M1004", //"发送名片"
  SIGN: "M1005", //"签到消息"
  SEND_PIC: "M1006", //"发送照片"
  SEND_RED_PACKET: "M1007", //"发送红包"
  SEND_RESOURCE: "M1008", //"发送资源"
  SEND_WISH: "M1009", //"发送祝福"
  SEND_EXCHANGE_CARD: "M1010", //"交换名片请求"
  RESPONSE_EXCHANGE_CARD: "M1011", //"交换名片请求回复"
  CONFIRM_RED_PACKET: "M1012", //"获取红包成功"
  INIT_USER: "M2001", //"初始化注册用户"
  INIT_LIVE: "M2002", //"初始化活动"
  CLEAR_LIVE: "M2003", //"清除活动"
  CREATE_WX_LIVE: "M2004", //"创建微信直播"
  INIT_LOTTERY: "L0001", //"初始化抽奖"
  JOIN_LOTTERY: "L0002", //"加入抽奖"
  WINNER_NOTICE: "L0003", //"中奖通知"
  CLOSE_LOTTERY: "L0004", //"抽奖结束"
  WRITE_OFF: "L0005", //"核销成功"
  QUIT_LOTTERY: "L0006", // "退出抽奖"

  BUY_EGG: "L0007", // "购买金蛋"),
  LOCK_EGG: "L0008", // "锁定金蛋"),
  INIT_EGG: "L0009",//"初始化金蛋"),
  UN_LOCK_EGG: "L0010",// "释放金蛋"),

  READY_GAME: "M3001", //"准备开始游戏"
  START_GAME: "M3002", //"开始游戏"
  END_GAME: "M3003", //"结束游戏"
  REPLAY_GAME: "M3004", //"再来一次"
  JOIN_GAME: "M3005", //"加入游戏"
  REFRESH_SCORE: "M3006", //"刷新分数"
  OPEN_WISH_WALL: "M3007" // "打开祝福"
}

export const getDefaultBless = (type) => {
  switch (type) {
    case "wedding":
      return Wedding_Bless;
    case "chat_group":
      return chatGroup;
    case "meeting_sales":
      return meetingSales;
    case "company_meeting":
      return companyMeeting;
    case "uyghur_wedding": // 修复：后端code下划线，之前是空格bug
      return uyghur_Wedding;
    case "community_activity":
      return communityActivity;
    case "birthday":
      return birthdayBless;
    case "lottery":
      return lotteryBless;
    case "business_activity":
      return businessActivityBless;
    case "graduation_banquet":
      return graduationBanquetBless;
    case "memorial":
      return memorialBless;
    case "jobHunt":
      return jobHunt;
    default:
      return defaultBless;
  }
};
